export const TEXT_TRANSLATION = 'builder.resume_editor.document_customization.sidebar.text_tab'
export const TEXT_TAB_TRANSLATION = 'builder.resume_editor.design_tab.text'

export const FALLBACK_FONT_WEIGHTS = {
  primaryFontWeight: 'regular',
  secondaryFontWeight: 'regular',
  bodyFontWeight: 'regular',
  sectionTitlesFontWeight: 'regular',
}
